var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(682 314)",
    fill: "#fff",
    stroke: "current",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-682 -314)",
    clipPath: "url(#trash)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.077,15a.587.587,0,0,1-.615-.487L1.285,3.215H.615A.58.58,0,0,1,0,2.679a.58.58,0,0,1,.615-.536H4.923V1.608A1.741,1.741,0,0,1,6.77,0H9.231a1.74,1.74,0,0,1,1.845,1.608v.536h4.308A.58.58,0,0,1,16,2.679a.58.58,0,0,1-.615.536h-.668l-1.178,11.3a.586.586,0,0,1-.614.487Zm.562-1.072h8.723L13.48,3.215H2.523ZM6.154,1.608v.536H9.846V1.608a.58.58,0,0,0-.615-.536H6.77A.58.58,0,0,0,6.154,1.608Zm4.308,11.254h-.047a.566.566,0,0,1-.568-.574l.615-7.5a.594.594,0,0,1,.659-.5.568.568,0,0,1,.572.574l-.615,7.5a.588.588,0,0,1-.614.5Zm-3.077-.536v-7.5a.621.621,0,0,1,1.231,0v7.5a.621.621,0,0,1-1.231,0Zm-1.846.536a.587.587,0,0,1-.615-.5l-.615-7.5a.568.568,0,0,1,.571-.574.6.6,0,0,1,.659.5l.615,7.5v0a.566.566,0,0,1-.571.571Z",
    transform: "translate(682 314.498)",
    fill: "#979797"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.896ab2a0ab9cbb0197d85544baf85b6d.svg";
export { ForwardRef as ReactComponent };